/*
=========================================================
* Vuetify Soft UI Dashboard PRO - v1.0.0
=========================================================

* Product Page:  https://store.vuetifyjs.com/products/vuetify-soft-ui-dashboard-pro
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import Vue from "vue";
import {
  Login,
  ChangeTmpPassword,
  ResetPassword,
  SelectEnterprise,
} from "@bag-era/cognito-authentication";
import i18n from './i18n';
import Auth from "@aws-amplify/auth";
import cognitoconfig from "./aws-config.js";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import DashboardPlugin from "./plugins/dashboard-plugin";
import axiosInstance from "./api/utils";
import "./css-helpers.css";
import "leaflet/dist/leaflet.css";

Vue.config.productionTip = false;

Auth.configure(cognitoconfig);
Vue.use(Login, ChangeTmpPassword, ResetPassword, SelectEnterprise);

// Vue.use(VueI18n);
// const i18n = new VueI18n({
//   locale: "fr",
//   messages: {
//     en: {},
//     fr: {},
//   },
//   fallbackLocale: "fr",
// });

// Photoswipe Gallery
import Photoswipe from "vue-pswipe";
Vue.use(Photoswipe);

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(Auth);

new Vue({
  i18n,
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount("#app");

// -- INTERCEPTOR
axiosInstance.interceptors.request.use(function (config) {
  // console.log("TOKEN USER", store.getters.isLogged);
  if (store.getters.isLogged) {
    return Auth.currentSession()
      .then((session) => {
        // User is logged in. Set auth header on all requests
        // console.log("SESSION: ", session);
        config.headers.Authorization = session.idToken.jwtToken;
        return Promise.resolve(config);
      })
      .catch((err) => {
        // No logged-in user: don't set auth header - got to login page
        console.error(err);
      });
  }
  return Promise.resolve(config);
});
